import { render, staticRenderFns } from "./goodsCate.vue?vue&type=template&id=2dce4f6c&scoped=true&"
import script from "./goodsCate.vue?vue&type=script&lang=js&"
export * from "./goodsCate.vue?vue&type=script&lang=js&"
import style0 from "./goodsCate.vue?vue&type=style&index=0&id=2dce4f6c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dce4f6c",
  null
  
)

export default component.exports